import GeoJSONLayer from '@arcgis/core/layers/GeoJSONLayer';

import keys from './shellfish/keys';
import {stateLayerPopup} from './shellfish/statePopup';


const presenceRenderer = {
	type: 'unique-value',
	field:'speciesPresence',
	legendOptions: {
		title: ' '
	},
	defaultLabel: 'Species Not Known to be Present',
	defaultSymbol: {
		type: "simple-fill",  // autocasts as new SimpleMarkerSymbol()
		size: 6,
		color: "black",
		outline: {  // autocasts as new SimpleLineSymbol()
		  width: 0.5,
		  color: "white"
		}
	},
	uniqueValueInfos: [{
		value:1,
		label: 'Species Present in State',
		symbol: {
			type: "simple-fill",  // autocasts as new SimpleMarkerSymbol()
			size: 2,
			color: "blue",
			outline: {  // autocasts as new SimpleLineSymbol()
				width: 2,
				color: "blue"
			},
			style: "cross"
		}
	},{
		value:2,
		label: 'Species Present and Monitoring Data Available',
		symbol: {
			type: "simple-fill",  // autocasts as new SimpleMarkerSymbol()
			size: 2,
			color: "purple",
			outline: {  // autocasts as new SimpleLineSymbol()
				width: 2,
				color: "purple"
			},
			style: "diagonal-cross"
		}
	}]
};

const pathogenRenderer = {
	type: 'unique-value',
	field:'speciesWithPathogenPresent',
	legendOptions: {
		title: ' '
	},
	defaultLabel: 'No Evidence of Occurrence',
	defaultSymbol: {
		type: "simple-fill",  // autocasts as new SimpleMarkerSymbol()
		size: 6,
		color: "black",
		outline: {  // autocasts as new SimpleLineSymbol()
		  width: 0.5,
		  color: "white"
		}
	},
	uniqueValueInfos: [{
		value:1,
		label: 'Historical / Anecdotal Occurrence',
		symbol: {
			type: "simple-fill",  // autocasts as new SimpleMarkerSymbol()
			size: 2,
			color: "yellow",
			outline: {  // autocasts as new SimpleLineSymbol()
				width: 2,
				color: "yellow"
			},
			style: "cross"
		}
	},{
		value:2,
		label: 'Detected Through Monitoring Data',
		symbol: {
			type: "simple-fill",  // autocasts as new SimpleMarkerSymbol()
			size: 2,
			color: "orange",
			outline: {  // autocasts as new SimpleLineSymbol()
				width: 2,
				color: "orange"
			},
			style: "diagonal-cross"
		}
	}]
}


const createSpeciesWithPathogen = (speciesKey=null, pathogenKey=null) => {

	let title = 'Atlantic and Gulf States';

	let speciesName = null;
	let pathogenName = null;
	let useRenderer = null;

	if( speciesKey ) {
		speciesName=keys.species[speciesKey].name;
		if(pathogenKey) {
			pathogenName=keys.pathogens[pathogenKey].name;
			title =  `${keys.species[speciesKey].name} (${keys.species[speciesKey].sciName}): ${keys.pathogens[pathogenKey].name}`;
			useRenderer=pathogenRenderer;
		}else{
			title = `States With ${keys.species[speciesKey].name} (${keys.species[speciesKey].sciName})`;
			useRenderer=presenceRenderer;
		}
	}else{
		title = `${keys.pathogens[pathogenKey].name}`;
		pathogenName=keys.pathogens[pathogenKey].name;
	}

	//value of zero or not 1/2 means not known to be present
	const myPresenceLayer = new GeoJSONLayer({
		url: `${process.env.REACT_APP_API_URL}/layers/states`  //?species=${keys.species[speciesKey].name}&pathogen=${keys.pathogens[pathogenKey].name}`
		,title
		,opacity: .5
		, customParameters: {
			species: speciesName,
			pathogen: pathogenName
		}
		,popupEnabled: true
		,popupTemplate: {
			outFields: ['*'],
			title: "<strong>{NAME}</strong>",
			content: stateLayerPopup
		}
		,renderer: useRenderer
	});


	return 	myPresenceLayer;
}





export const statesJson = {
	id: `state-geojson-group`,
	type: 'group',
	items: Object.keys( keys.species ).map( (speciesKey) => {
		const myItem = keys.species[speciesKey];

		return {
			title: `${myItem.name} (${myItem.sciName})`,
			id: `state-geojson-group-${speciesKey}`,
			type: 'group',
			items: [
				{
					layerId: `rssbp-ssapd-${speciesKey}`,
					type: 'layer',
					item: createSpeciesWithPathogen(speciesKey),
					meta: null
				}
			]
			.concat( 
				Object.keys( keys.pathogens ).filter( (pathogenKey) => {
					if( !keys.speciesPathogenMatrix[speciesKey] ) {
						return false;
					}
					//console.log('[???????????]', keys.speciesPathogenMatrix[speciesKey].includes(pathogenKey) );
					return keys.speciesPathogenMatrix[speciesKey].includes(pathogenKey);
				}).map( (pathogenKey) => {
					return {
						layerId: `rssbp-ssapd-${speciesKey}-${pathogenKey}`,
						type: 'layer',
						item: createSpeciesWithPathogen(speciesKey, pathogenKey),
						meta: null
					};
				})
			)
		}
	}),
	
	/*[
		{
			layerId: `state-geojson`,
			type: 'layer',
			item: myGeojsonTest
		}

	],
	*/
	title: `State Species & Pathogen Distribution`//(Geojson) 
}



//This is find species in state, and then break out by diseases if necessary.
